const topCompetitorDataset = [
  {
    productName: 'Nutrisari',
    price: 5000,
    amountSold: 1000,
    src: "https://s1.bukalapak.com/img/1833889354/w-1000/IMG_20181114_191146_scaled.jpg"
  },
  {
    productName: 'Kacang Dua Kelinci',
    price: 2500,
    amountSold: 950,
    src: "https://ecs7.tokopedia.net/img/cache/700/product-1/2018/2/17/7760780/7760780_2f53aac9-fd6d-4d65-b074-2eda8c35e138_2048_2594.jpg"
  },
  {
    productName: 'Lays',
    price: 400,
    amountSold: 875,
    src: "https://s1.bukalapak.com/img/11961401411/w-1000/Lays_Potato_Rumput_Laut_168g.jpg"
  },
  {
    productName: 'Caramel Corn',
    price: 12000,
    amountSold: 750,
    src: "https://ecs7.tokopedia.net/img/cache/700/product-1/2017/10/23/164922028/164922028_bb89d3fa-c4d3-4c5f-9cf5-3b6480501985_679_545.jpg"
  },
  {
    productName: 'Cheetos Puffz BBQ',
    price: 400,
    amountSold: 700,
    src: "https://cf.shopee.co.id/file/be903e6cdff9f34d8cabb37ca0c68a48"
  },
];

export default topCompetitorDataset;